module.exports = __webpack_public_path__ + "img/logo_sub_nav.a3ee4f0e.png";